const BeninSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110901)">
      <path
        d="M13.0435 18.2598L14.7826 39.3099C16.4461 39.7583 18.1947 39.9989 19.9999 39.9989C31.0456 39.9989 39.9999 31.0445 39.9999 19.9989L13.0435 18.2598Z"
        fill="#D80027"
      />
      <path
        d="M13.0435 20L14.7825 0.688984C16.4461 0.240625 18.1947 0 19.9999 0C31.0456 0 39.9999 8.95437 39.9999 20H13.0435Z"
        fill="#FFDA44"
      />
      <path
        d="M0 19.9995C0 29.24 6.26727 37.0155 14.7826 39.3105V0.688477C6.26727 2.98348 0 10.7589 0 19.9995Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110901">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default BeninSvg;
